import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { Alert, Alignment, Button, FormGroup } from "@blueprintjs/core";
import { ManifestacoesStore } from "../../stores/manifestacoes/ManifestacoesStore";
import { getTag } from "../utils/getStatus";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { formatCnpj } from "../../utils";

@observer
export default class TarefasManifestacoes extends React.Component<{}, {}> {

  obs = observable({
    tarefas_page: 1 as number,
    erros_relatorio: [] as any,
    open_erros_relatorio: false as boolean,
    selectedEmpresa: newEmpresa() as IEmpresa,
    modelo: "" as string,
    status: "" as string
  })

  constructor(props: any) {
    super(props);
  }

  handleBuscaTarefas = async (page: number) => {
    ManifestacoesStore.handleConsultaTasksManifestacoesDownload(page, 15, this.obs.selectedEmpresa.cnpj, this.obs.modelo, this.obs.status);
  };

  handleErrosRelatorio(error: string) {
    let list_erros = error.split(",")

    this.obs.erros_relatorio = list_erros?.map(x => {
      return { "erros": x }
    })

    ManifestacoesStore.obs.open_erros_relatorio = true
  }

  onCloseErros() {
    ManifestacoesStore.obs.open_erros_relatorio = false
    this.obs.erros_relatorio = []
  }

  handleFilterModeloChange = (e: any) => {
    var string = e.target.value;
    this.obs.modelo = string;
  };

  handleFilterStatusChange = (e: any) => {
    var string = e.target.value;
    this.obs.status = string;
  };

  handleBuscaClick = async () => {
    this.obs.tarefas_page = 1

    await ManifestacoesStore.handleConsultaTasksManifestacoesDownload(this.obs.tarefas_page, 15, this.obs.selectedEmpresa.cnpj, this.obs.modelo, this.obs.status);
  };

  render() {

    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 35)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";

    function stringFormatter(cell, row) {
      if (!cell) return "";
      return (cell).toUpperCase();
    };

    function statusFormatter(cell, row) {

      return getTag(row.status);
    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const errosFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 3}
            onClick={() => this.handleErrosRelatorio(row.error)}
          >
            <img src="/images/view.png" />
          </MDBBtn>
        </>
      );
    }

    function getRazaoSocial(cell, row) {
      let emp = EmpresaStore.getByCnpj(cell);

      return emp.razao_social

    }

    return (
      <>

        <MDBRow>
          <MDBCol xl="4" lg="4" md="4" sm="4" xs="12">
            <FormGroup label="Empresa" className="empresaSelect">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol xl="2" lg="2" md="2" sm="2" xs="12">
            <FormGroup
              label="Modelo"
              className="nz-horizontal-field selectFullWidth"
            >
              <select
                onChange={this.handleFilterModeloChange}
                className="bp3-button bp3-align-left"
              >
                <option value="">Todos</option>
                <option value="nfe">NF-e</option>
                <option value="nfce">NFC-e</option>
                <option value="cte">CT-e</option>
                <option value="nfse">NFS-e</option>
              </select>
            </FormGroup>
          </MDBCol>
          <MDBCol xl="2" lg="2" md="2" sm="2" xs="12">
            <FormGroup
              label="Status"
              className="nz-horizontal-field selectFullWidth"
            >
              <select
                onChange={this.handleFilterStatusChange}
                className="bp3-button bp3-align-left"
              >
                <option value="">Todas</option>
                <option value={0}>Novo</option>
                <option value={1}>Processando</option>
                <option value={2}>Concluído</option>
                <option value={3}>Erro Solicitação</option>
              </select>
            </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={this.handleBuscaClick}
              disabled={niveis_acesso.indexOf("h1") == -1}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <Alert
          confirmButtonText="Fechar"
          isOpen={ManifestacoesStore.obs.open_erros_relatorio}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
        >
          <h2 className="titleSEFAZ">Erros</h2>
          <MDBCol md="12">
            {this.obs.erros_relatorio.length &&
              <div className="errosSped">
                <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                </BootstrapTable>
              </div>
            }
          </MDBCol>
        </Alert>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={ManifestacoesStore.obs.tasks_manifestacoes_nfse} data-tut="table">
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
            <TableHeaderColumn dataFormat={getRazaoSocial} dataField="cnpj" width="20%">Empresa</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="15%">Data</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="_modifiedTS" width="15%">Data Atualização</TableHeaderColumn>
            <TableHeaderColumn dataFormat={stringFormatter} dataField="modelo" width="5%">Modelo</TableHeaderColumn>
            <TableHeaderColumn dataAlign="center" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={errosFormatter} width="5%">Detalhes</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={ManifestacoesStore.obs.length_tasks_manifestacoes_nfse}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefas(this.obs.tarefas_page = page)}
          />
        </div>
      </>
    )
  }
}

